@if (edit) {
  <div class="app app-ai-summary-edit">
    <div class="p-3">
      @if (title) {
        <div>
          <h4>{{ caseSummaryLabel }}</h4>
          <p>{{ caseSummaryPrompt }}</p>
        </div>
      }
      <div>
        @if (summaryLoading || generateSummaryLoading) {
          <div class="summary-loading-spinner"
            ><mat-spinner diameter="48"></mat-spinner
            ><span>Loading AI Summary...</span></div
          >
        } @else {
          <div>
            @if (aiGenerateBtn) {
              <div>
                <div class="regenerate-summary-text"
                  >This case has been modified since the following summary was
                  generated.</div
                >
                <button matButton="elevated" (click)="triggerGenerateSummary()"
                  >Regenerate AI Case Summary</button
                >
              </div>
            }
            <div class="ai-summary-edit-section">
              <div class="ai-summary-edit-text w-100">
                <div
                  class="summary-notification"
                  [ngClass]="{ valid: caseSummaryChecked }"
                >
                  @if (caseSummaryChecked) {
                    <mat-icon class="mr-1">thumb_up</mat-icon>Summary Reviewed
                  } @else {
                    <mat-icon class="mr-1">error</mat-icon>Please Click the
                    Checkbox to Confirm You Have Reviewed the Summary
                  }
                </div>
                <ngx-editor-menu
                  [editor]="editor"
                  [toolbar]="toolbar"
                  [customMenuRef]="revertToOriginalBtn"
                  [disabled]="!text || aiSummaryReadOnly"
                >
                </ngx-editor-menu>
                <ngx-editor
                  [editor]="editor"
                  [(ngModel)]="text"
                  [formControl]="messageControl"
                  [placeholder]="caseSummaryPlaceholder"
                ></ngx-editor>
                <ng-template #revertToOriginalBtn>
                  <div class="NgxEditor__Seperator"></div>
                  <button matButton (click)="revertOriginalTrigger($event)"
                    >Revert Back to Original</button
                  >
                </ng-template>
              </div>
            </div>
            <div class="summary-actions-disclosure-container">
              <div class="ai-summary-footnote">{{ caseSummaryDisclosure }}</div>
              <div class="summary-actions-container">
                <div class="checkbox-content-container">
                  <mat-checkbox
                    [checked]="caseSummaryChecked"
                    (change)="summaryCheckChanged($event)"
                    >{{ caseSummaryCheckBoxText }}</mat-checkbox
                  >
                  @if (!caseSummaryChecked && manualEdit && !neverChecked) {
                    <div class="edit-warn"
                      >There have been edits since the last review.</div
                    >
                  }
                </div>
                <button
                  mat-raised-button
                  color="primary"
                  (click)="submitSummary()"
                  >Save</button
                >
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  @if (text) {
    <div class="app app-ai-summary">
      <div class="col-12 row">
        @if (title) {
          <div>
            <h4> AI Case Summary </h4>
          </div>
        }
        <div>
          <div>
            <div class="ai-summary-section">
              <div class="ai-summary-text" [innerHTML]="text"> </div>
            </div>
            <div class="ai-summary-footnote"
              >*Note: This summary was generated using AI.</div
            >
          </div>
        </div>
      </div>
    </div>
  }
}
